import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '8 - 1x2',
  imageCount: 4,
  displayGroup: 'DG_EXCHANGE',
  calc: (height) => {
    const pWidth = height / 4;
    const pHeight = pWidth * ASPECT_RATIO;

    return {
      gridTemplate: `
        'p1 p2 p3 p4' ${pWidth}px
        'p5 p6 p7 p8' ${pWidth}px
        '. . . .' ${height / 2}px
        / ${pHeight}px ${pHeight}px ${pHeight}px ${pHeight}px`,
      photos: gridPhotos(1, 8, pWidth, pHeight, -90)
    };
  }
};
